export default function Footer() {
  return (
    <footer className="mt-24 border-t border-slate-200/70 bg-white">
      <div className="container-optia py-10 grid gap-8 md:grid-cols-4">
        <div className="md:col-span-1">
          <h4 className="font-display font-semibold text-navy-900 text-lg">Optia Saúde</h4>
          <p className="text-sm text-slate-600 mt-2 max-w-xs">Telemedicina afirmativa para pessoas neurodivergentes. Cuidado com respeito, sem julgamentos.</p>
        </div>

        <div className="text-sm text-slate-600 md:col-span-2">
          <h5 className="font-medium text-navy-900 mb-2">Dados da empresa</h5>
          <p><b>Optia Saúde</b></p>
          <p>CNPJ 59.344.899/0001-02</p>
          <p>Av. das Américas, nº 18.500 — sala 647</p>
          <p>Recreio dos Bandeirantes — Rio de Janeiro / RJ</p>
          <p className="mt-2">Responsável técnico:{" "}
            <a href="mailto:drasaritaortega@gmail.com" className="text-teal-700 hover:underline">drasaritaortega@gmail.com</a>
          </p>
        </div>

        <div className="text-sm text-slate-600">
          <h5 className="font-medium text-navy-900 mb-2">Precisa de ajuda urgente?</h5>
          <p>CVV — Ligue 188 (24h, gratuito)</p>
          <p>Emergência médica — 192 (SAMU)</p>
        </div>
      </div>

      <div className="border-t border-slate-200/70">
        <div className="container-optia py-4 flex flex-wrap items-center justify-between gap-2 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} Optia Saúde. Todos os direitos reservados.</span>
          <span>Feito com cuidado — em português.</span>
        </div>
      </div>
    </footer>
  );
}
